import { render, staticRenderFns } from "./Schedule.vue?vue&type=template&id=2236a9bc&scoped=true&"
import script from "./Schedule.vue?vue&type=script&lang=js&"
export * from "./Schedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2236a9bc",
  null
  
)

export default component.exports